/// <reference types="@types/google.maps" />
export const GOOGLE_MAPS_ICON_PATH = 'https://static.ratemyagent.com.au/assets/images/maps/';
export const GOOGLE_MAPS_STATIC_MARKER = `${GOOGLE_MAPS_ICON_PATH}primary.png`;
export const GOOGLE_MAPS_STATIC_URL = 'https://maps.googleapis.com/maps/api/staticmap';

export const GOOGLE_MAPS_STATIC_REVIEWS_MARKER = `${GOOGLE_MAPS_ICON_PATH}review-standard.png`;
export const GOOGLE_MAPS_STATIC_PROPERTY_MARKER = `${GOOGLE_MAPS_ICON_PATH}default-standard.png`;

export const GOOGLE_MAPS_STATIC_CACHE_PREFIX = 'STATIC_MAP';

export const DEFAULT_GOOGLE_MAP_OPTIONS: google.maps.MapOptions = {
  mapId: 'RMA_MAP',
  clickableIcons: false,
  mapTypeControlOptions: {
    mapTypeIds: [],
  },
  styles: [
    {
      featureType: 'poi',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ],
  zoom: 17,
};

export const MAP_AREA_TRANSLATION_KEY = 'loading.mapArea';
